import { render, staticRenderFns } from "./MediaLeftAlignBorder.vue?vue&type=template&id=c94f7a24"
import script from "./MediaLeftAlignBorder.vue?vue&type=script&lang=js"
export * from "./MediaLeftAlignBorder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports